export function fmt(n) {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency', currency: 'TRY',
    minimumFractionDigits: 2, maximumFractionDigits: 2
  }).format(n || 0);
}

export function formatQuantity(n, unit) {
  if (!n && n !== 0) return '';
  return new Intl.NumberFormat('tr-TR').format(n) + ' ' + (unit || '');
}
